import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		}
		return { x: 0, y: 0 }
	}
})
// منع العودة لصفحة تسجيل الدخول إذا كان المستخدم مسجل دخول

router.beforeEach((to, from, next) => {
	// إذا كان المستخدم مسجل دخول وحاول الذهاب إلى صفحة login
	if (to.name === 'login' && store.state.auth.authenticated) {
		// إعادة توجيهه للصفحة الرئيسية أو أي صفحة مناسبة
		return next({ name: 'visits' });
	}
	next();
});

export default router